<np-header [sitename]="'AI Prompt Builder'" [welcomeMessage]="welcome"></np-header>
<np-nav [navItems]="navigationItems"></np-nav>
<div class="app-container">

  @if (isLoading) {

    <div class="messaging">   
      Authorizing...     
    </div>
  
  } @else {
  
    <router-outlet />
  
  }
  </div>
<np-footer
    [contentContactUrl]="'mailto:Corporate-Affairs-Agile@chevron.onmicrosoft.com'"
    [contentContactName]="'CA Digital Platform'"
    [technicalContactUrl]="'mailto:Corporate-Affairs-Agile@chevron.onmicrosoft.com'"
    [technicalContactName]="'CA Digital Platform'"
    [opCoUrl]="'https://intranet.chevron.com/'"
    [opCoName]="'Corporate Affairs'"
></np-footer>